<template>
  <section class="bg-blue-400">Select</section>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "selectMaterialForm",
});
</script>
